<template>
  <svg
    :class="svgClass"
    :width="computedWidth"
    :height="computedHeight"
    aria-hidden="true"
  >
    <use :href="iconName" />
  </svg>
</template>
<script setup>
import { computed } from 'vue'

/* =======================
   Props
   ======================= */
const props = defineProps({
  name: {
    type: String,
    required: true,
    default: ''
  },
  className: {
    type: String,
    default: ''
  },
  width: {
    type: String,
    default: '1em'
  },
  height: {
    type: String,
    default: '1em'
  }
})

/* =======================
   Computed
   ======================= */
const iconName = computed(() => `#icon-${props.name || 'default'}`)

const svgClass = computed(() => [
  'icon-svg',
  `icon-svg__${props.name || 'default'}`,
  props.className && /\S/.test(props.className) ? props.className : ''
])

const computedWidth = computed(() => {
  if (!props.width || props.width === 'auto') {
    return '1em'
  }
  return props.width
})

const computedHeight = computed(() => {
  if (!props.height || props.height === 'auto') {
    return '1em'
  }
  return props.height
})
</script>

<style scoped>
.icon-svg {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>